import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';

export const StepTitle = ({ title, description }: { title: React.ReactNode; description?: React.ReactNode }) => (
    <Stack direction="column" gap="2">
        <Typography as="h4" fontWeight="bold" color="grey_1200">
            {title}
        </Typography>
        {description && (
            <Typography color="grey_1200" whiteSpace="preWrap">
                {description}
            </Typography>
        )}
    </Stack>
);
